module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "henkel"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/henkel.png"),
      "srcset": _vm.hk2x + ' 2x'
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', [_c('router-link', {
    attrs: {
      "to": "/terms"
    }
  }, [_vm._v("\n        使用條款\n      ")])], 1), _vm._v(" "), _c('div', [_c('router-link', {
    attrs: {
      "to": "/privacy"
    }
  }, [_vm._v("\n        私隱權守則\n      ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "copyright"
  }, [_vm._v("\n    © 2018 - 2022 Henkel\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-017b9057","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/footer/Footer.vue
// module id = 228
// module chunks = 0